import { getEnv, getMockAddress } from "#/utils/getEnv";
import sulamerica from "#/assets/logo_sulamericaodonto.png";
import sulamericaAns from "#/assets/ans_sulamerica.png";
import docway from "#/assets/logo_docway.png";

export const APPLICATION = {
    ID: process.env.REACT_APP_ID,
    NAME: `@${process.env.REACT_APP_ID.replace("-", "_").toUpperCase()}`,
    EXTERNAL: ["WEB_CRM", "WEB_PUBLIC"].includes(
        process.env.REACT_APP_JOB_TEMPLATE_TYPE
    ),
    get BFF_URL() {
        const env = getEnv();
        if (env === "mock") {
            return getMockAddress();
        }

        return window.env?.BFF_URL;
    },


    get ENV() {
        return getEnv();
    }
};

export const GATEWAY_URL = (): string => {
    return {
        "prd": "https://appseguros.sicredi.com.br",
        "uat": "https://appseguros.uat.sicredi.com.br",
        "stress": "https://appseguros.uat.sicredi.com.br",
        "dev": "https://segurosvitrine-consulta-mfe-web.dev.sicredi.cloud"
    }[window.env?.ENV ?? "dev"]!;
};

export const PAGE = {
    ROOT: () => "/",
    MY_PLAN: {
        ROOT: () => "/meu-plano",
        PAYMENT_DATA: () => `${PAGE.MY_PLAN.ROOT()}/dados-pagamento`,
        DEPENDENTS: {
            ROOT: () => `${PAGE.MY_PLAN.ROOT()}/dependentes`,
            NEW: () => `${PAGE.MY_PLAN.DEPENDENTS.ROOT()}/novos`,
            ADD: () => `${PAGE.MY_PLAN.DEPENDENTS.NEW()}/adicionar`,
            UPDATE: () => `${PAGE.MY_PLAN.DEPENDENTS.NEW()}/editar`
        },
        CONTACT: () => `${PAGE.MY_PLAN.ROOT()}/contatos`,
        CONTRACT_DATA: {
            ROOT: () => `${PAGE.MY_PLAN.ROOT()}/dados-contrato`,
            COMPLEMENTARY_DATA: () =>
                `${PAGE.MY_PLAN.CONTRACT_DATA.ROOT()}/dados-complementares`,
            DETAILS_PLAN: () => `${PAGE.MY_PLAN.CONTRACT_DATA.ROOT()}/detalhes-plano`
        }
    },
    NOT_AUTHENTICATED: () => "/nao-autenticado",
    NOT_FOUND: () => "/nao-encontrada",
    ERROR: () => `/erro`,
    SUCCESS: () => `/sucesso`
};

export enum TYPES_PLANS {
    TELEMEDICINE = "TELEMEDICINE",
    DENTAL = "DENTAL",
}

export enum COMPANIES {
    SULAMERICA = "SULAMERICA",
    DOCWAY = "DOCWAY",
}

export const logos = {
    [COMPANIES.SULAMERICA]: sulamerica,
    [COMPANIES.DOCWAY]: docway
};

export const PRODUCTS_NAMES = {
    [TYPES_PLANS.DENTAL]: "Odonto",
    [TYPES_PLANS.TELEMEDICINE]: "Telemedicina"
};

export enum PLAN_STATUS {
    SIMULATION = "SIMULATION",
    PROPOSAL = "PROPOSAL",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    CANCELED = "CANCELED",
    CANCELING = "CANCELING",
    REFUSED = "REFUSED",
    EXPIRED = "EXPIRED",
    FINISHED = "FINISHED",
    COLLECTING = "COLLECTING",
    CREATING = "CREATING",
    ERROR = "ERROR",
}

export enum TYPES_PHONES {
    WHATSAPP = "WHATSAPP",
    PHONE = "PHONE",
}

export enum PAYMENTS_OPTIONS {
    ACCOUNT_DEBIT = "ACCOUNT_DEBIT",
}

export const EXTERNAL_LINKS_CONTRACT: {
    [keyTypePlan in TYPES_PLANS]?: {
        [keyCompany in COMPANIES]?: { title: string; link: string }[];
    };
} = {
    [TYPES_PLANS.DENTAL]: {
        [COMPANIES.SULAMERICA]: [
            {
                title: "Condições gerais",
                link: "https://www.sulamerica.com.br/odonto/CG_Totality_INSP.pdf"
            }
        ]
    },
    [TYPES_PLANS.TELEMEDICINE]: undefined
};

export const ansImages = {
    [COMPANIES.SULAMERICA]: sulamericaAns
};

export enum PAGES {
    PLANS = "PLANS",
    MY_PLAN = "MY_PLAN",
    CONTACT = "CONTACT",
    CONTRACT = "CONTRACT",
    DEPENDENTS = "DEPENDENTS",
    ADD_DEPENDENT = "ADD_DEPENDENT",
    NEW_DEPENDENTS = "NEW_DEPENDENTS",
    PAYMENT = "PAYMENT",
    DETAILS_PLAN = "DETAILS_PLAN",
    COMPLEMENTARY_DATA = "COMPLEMENTARY_DATA",
}

export const TYPES_PLANS_DESCRIPTION: { [key in TYPES_PLANS]: string } = {
    [TYPES_PLANS.DENTAL]: "odontológico",
    [TYPES_PLANS.TELEMEDICINE]: "de telemedicina"
};
